import { StateCreator } from 'zustand';

// Types
import { AuthSlice, AuthState } from './types';

// Re-export types
export type { AuthSlice } from './types';

const initialAuthState: AuthState = {
  isAuthorized: false,
  shouldForceLogout: false,
  message: '',
  isLoggingOut: false,
  hasBeenAuthorized: false,
};

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (
  set,
) => ({
  ...initialAuthState,

  setAuthorized: (value: boolean) => {
    set({ isAuthorized: value });
    // Track if user has been authorized
    if (value) {
      set({ hasBeenAuthorized: true });
    }
  },
  setMessage: (value: string) => set({ message: value }),
  setForceLogoutWithMessage: (message: string) =>
    set({ shouldForceLogout: true, message }),
  setIsLoggingOut: (value: boolean) => set({ isLoggingOut: value }),
  setHasBeenAuthorized: (value: boolean) => set({ hasBeenAuthorized: value }),
  resetAuth: () =>
    set({
      isAuthorized: false,
      shouldForceLogout: false,
      message: '',
      isLoggingOut: false,
      hasBeenAuthorized: false,
    }),
});
